import Layout from '@/views/layout/Layout'
const independentRouter = {
    path: '/userCenter',
    name: 'userCenter',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 独立企业系统路由
        {
            path: 'logindependentSystem',
            name: 'logindependentSystem',
            component: () => import('@/views/userCenter/independent/logindependentSystem'),
        },
        // 独立企业系统申请支付路由
        {
            path: 'logindependentPay',
            name: 'logindependentPay',
            component: () => import('@/views/userCenter/independent/logindependentPay'),
        },
        // 独立企业系统功能设置路由
        {
            path: 'logindependentSet',
            name: 'logindependentSet',
            component: () => import('@/views/userCenter/independent/logindependentSet'),
        },
        // 独立企业系统订单列表路由
        {
            path: 'logorderIndependent',
            name: 'logorderIndependent',
            component: () => import('@/views/userCenter/independent/logorderIndependent'),
        },
    ]
}
export default independentRouter


// WEBPACK FOOTER //
// ./src/router/modules/independent.js